import React, { useEffect, useState } from 'react'
import { Button, Stepper } from '@sede-enterprise/shell-ds-react-framework';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { azureFetch } from '../../api/azureFetch';


const responseMap = {
    "Data Extraction": "Data Extraction Completed",
    "Pipeline Creation": "Pipeline Creation Completed",
    "Model Training": "Model Training Completed",
    "Model Predictions": "Model Predictions Completed",
}

const steps = Object.keys(responseMap);

const ModelTrainStatus = ({ match }) => {
    const history = useHistory()
    const [currentStep, setCurrentStep] = useState(0);
    const [completedSteps, setCompletedSteps] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);
    const [modelId, setModelId] = useState(null);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        // Initial status check when the component mounts
        refreshStatus();
    }, [match.params.id]);



    const refreshStatus = async () => {
        if (match.params.id) {
            try {
                setLoading(true);
                const res = await azureFetch(`getCAMJobStatus/${match.params.id}`);

                const completedStepIndex = steps.findIndex(
                    (step) => responseMap[step] === res
                );

                if (completedStepIndex !== -1) {
                    // Highlighted change: Mark all steps up to the current step as completed
                    const updatedSteps = Array.from({ length: completedStepIndex + 1 }, (_, i) => i);
                    setCompletedSteps(updatedSteps);

                    setCurrentStep(completedStepIndex + 1);
                    setErrorMessage(null); // Clear any previous error
                }

                else {
                    if (typeof res === 'string') {
                        setCompletedSteps(Array.from({ length: steps.length }, (_, i) => i));
                        setCurrentStep(steps.length);
                        setErrorMessage(null);
                        setModelId(res);
                    }
                }
            } catch (error) {
                console.error(error);
                setErrorMessage("Failed to fetch status. Please try again.");
            }
            finally {
                setLoading(false);
            }
        }
    };

    return (
        <div className='parent-container'>
            <div className='content-container'>
                <div className='model-train-status'>
                    {errorMessage ? (
                        <h4 className="error-message error-label">{errorMessage}</h4>
                    ) : (
                        <Stepper type="dot" current={currentStep} direction="horizontal">
                            {steps.map((step, index) => (
                                <Stepper.Step
                                    key={step}
                                    title={step}
                                    description={
                                        completedSteps.includes(index) ? (
                                            responseMap[step]
                                        ) : (
                                            // <Loading size='xsmall' />
                                            <></>
                                        )
                                    }
                                />
                            ))}
                        </Stepper>
                    )}

                    <div className='model-train-status-buttons'>
                        <Button onClick={refreshStatus} loading={loading} disabled={modelId}> Refresh Status</Button>
                        <Button
                            onClick={() => { if (modelId) history.push(`/models/${modelId}`); }}
                            disabled={!modelId}
                        >
                            View Results
                        </Button>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ModelTrainStatus